var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.65 41.95Q31.05 41.95 24.975 39.625Q18.9 37.3 14.225 33.175Q9.55 29.05 6.775 23.425Q4 17.8 4 11.2Q4 9 5.225 7.5Q6.45 6 8.7 6H13.35Q14.7 6 15.45 6.775Q16.2 7.55 16.5 9Q16.8 10.5 17.175 12.1Q17.55 13.7 18.05 14.95Q18.5 16 18.325 16.925Q18.15 17.85 17.3 18.7L13.4 22.5Q15.8 26 20.075 29.275Q24.35 32.55 28.4 33.75L30.7 29.1Q31.15 28.2 31.85 27.875Q32.55 27.55 33.8 27.65Q35.1 27.75 36.375 27.75Q37.65 27.75 39.25 27.65Q40.75 27.55 41.775 28.45Q42.8 29.35 43.15 31.35L43.95 35.85Q43.95 35.85 44.05 36.7Q44.05 38.8 42.325 40.375Q40.6 41.95 37.65 41.95Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.197add5f0abf356a6183b9948e35e499.svg";
export { ForwardRef as ReactComponent };